<template>
	<div id="app-cookie-message">
		<section>
			<p>By clicking "Accept & Continue", you agree to the storing of cookies on your device to enhance site navigation, personalising content, providing social media features and to analyse how our website is used.</p>
			<router-link class="cookie" to="/cookie-policy">Cookie Policy</router-link>
			<router-link class="privacy" to="/privacy-policy">Privacy Policy</router-link>
			<button class="accept" @click="appSetCookie(true)">Accept & Continue</button>
			<button class="cancel" @click="appSetCookie(false)">Decline</button>
		</section>
	</div>
</template>

<script>
import { appMethods } from '@/features/app/store'
export default {
	methods: {
		...appMethods
	}
}
</script>